import axios from '@/libs/http'

export const getGiftBook = ()=>{ //获取礼物成就列表
    return axios.request({
        url: '/s/c/giftBook/listCategory',
        params: {
        },
        method: 'GET'
    })
}

export const getGiftBookList = ({categoryId} = {})=>{ //获取礼物成就列表
    return axios.request({
        url: '/s/c/giftBook/list',
        params: {
            categoryId,
        },
        method: 'GET'
    })
}

//获取用户成就详情列表
export const getDetail = ({giftBookId} = {}) => {
    return axios.request({
        url: '/s/c/giftBook/getDetail',
        params: {
            giftBookId,
        },
        method: 'get'
    })
}

//领取奖励
export const receiveAward = ({giftBookId} = {}) => {
    return axios.request({
        url: '/s/c/giftBook/receiveAward',
        params: {
            giftBookId,
        },
        method: 'post'
    })
}